<div *ngIf="!errCode" class="renew-wrapper">Processing user information...<sync-icon name="Rolling-1s-40px" /></div>
<app-error *ngIf="errCode" [errcode]="errCode" />
